/** @format */

import React, { useRef } from 'react';
import { PageContainer, TableComponents, Icons } from 'components';
import { Grid, Button } from '@mui/material';
import { columns } from '../components/ColumnsMyDealer';
import { AddDealerDialog, DealerProductsListDialog } from '../components';
import DealerService from '../services';
import useCustomHook from '../hooks';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

const MyDealerView = () => {
  const {
    openDialog,
    setOpenDialog,
    openAllowedProductsDialog,
    setOpenAllowedProductsDialog,
    dealerBizId,
    setDealerBizId,
    allProductAllow,
    setAllProductAllow,
    loading, setLoading,
    size, setSize,
    page, setPage
  } = useCustomHook();

  const tableRef = useRef();
  const actionsList =
    getDynamicObjectAction([
      'listDealerPage',
      'addListDealerBtn',
      'toggleListDealerBtn',
      'productListDealerBtn'

    ]);
  const getDealerList = async (query) => {
    setLoading(true)
    const params = {
      offset: query ? query?.pageNumber * query?.pageSize : page * size,
      size: query ? query?.pageSize : size,
    };
    query?.filters?.forEach?.((f) => {
      params[f.column?.field] = f.value;
    });

    try {
      const data = await DealerService.getDealerList(params);
      const list = createData(data.result, {
        page: query ? query?.pageNumber : page,
        size: query ? query?.pageSize : size,
      });
      setLoading(false)
      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: data.count,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false)
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onChangeStatus = async (bizId, newStatus) => {
    try {
      await DealerService.toggleDealerStatus(bizId, newStatus);
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) { }
  };

  const showAllowedProducts = (rd) => {
    setDealerBizId(rd.id);
    setAllProductAllow(rd.allProductAllow);
    setOpenAllowedProductsDialog(true);
  };
  const createData = (data, params) => {
    const list = data.map((item, key) => {
      const dealer = item?.dealer;

      return {
        num: (params?.page ? params?.page : page) * (params?.pageSize ? params?.pageSize : size) + key + 1,
        name: dealer.name,
        id: dealer.id,
        numOfProducts: dealer.numOfProducts,
        sheba: dealer.sheba || '-',
        enable: item.enable,
        allProductAllow: item.allProductAllow,
      };
    });

    return list;
  };

  const addDealer = () => {
    setOpenDialog(true);
  };
  const hint =
    'در این بخش می‌توانید لیست کسب‌و‌کارهایی که مجوز کارگزاری از طرف شما دارند (کسب و کارهای دارای مجوز صدور فاکتور یا سهم از فاکتور از طرف کسب وکار شما) را مشاهده کنید.';

  return (
    <PageContainer
      meta={
        <>
          {actionsList['addListDealerBtn'] && (
            <Button
              startIcon={<Icons icon='plusCircle' color='#fff' size='18' />}
              onClick={addDealer}
              variant="contained"
              color="primary"
            >
              افزودن کارگزار
            </Button>
          )}
        </>
      }
      title='لیست کارگزاری های من'
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.DEALER_LIST}
    >
      {actionsList['listDealerPage'] && (
        <Grid item xs={12}>

          <TableComponents
            data={getDealerList}
            columns={columns(onChangeStatus, showAllowedProducts, actionsList)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getDealerList(ps)
            }}


          />
        </Grid>
      )}

      <AddDealerDialog open={openDialog} setOpen={setOpenDialog} tableRef={tableRef} />
      <DealerProductsListDialog
        open={openAllowedProductsDialog}
        setOpen={setOpenAllowedProductsDialog}
        dealerBizId={dealerBizId}
        allProductAllow={allProductAllow}
      />
    </PageContainer>
  );
};

export default MyDealerView;
